import React from 'react';

import useCDNUrl from '../../../hooks/useCDNUrl.js';

import {
    useIsExporting
} from '../../../hooks/useExport.js';

import {
    listeningDefinitions
} from './enums/listeningDefinitions.jsx';

export default function PoweredByQuid() {

    const quidLogo = useCDNUrl('/images/quid-logo-grey.png');

    if (useIsExporting()) {
        return null;
    }

    const {text, url} = listeningDefinitions['powered-by-quid'];
    return (
        <div
            className='tlw-flex tlw-items-center tlw-justify-center tlw-gap-5 tlw-pt-32 tlw-text-gray-675'
        >
            <span>
                Powered by
            </span>
            <img
                className='tlw-w-[86px] tlw-object-contain'
                src={quidLogo}
                alt='Quid Logo'
            />
            <div
                className='tlw-mx-5 tlw-h-[55px] tlw-border tlw-border-b-0 tlw-border-l-0 tlw-border-t-0 tlw-border-solid tlw-border-gray-675'
            />
            <span>
                {text}&nbsp;
                <a
                    href={url}
                    target='_blank'
                    rel='noreferrer'
                >
                    Learn More »
                </a>

            </span>
        </div>
    );
}
